/**
 * Datos de contacto del comprador.
 *
 * El sitio no tiene cuentas de cliente: estos tres campos son todo lo que se
 * sabe de quien compra, y son los que van al documento y al correo de
 * confirmacion (MAIL-01). El consentimiento de promociones se pide aca, apagado
 * por defecto, porque la normativa chilena exige que sea un acto explicito
 * (MAIL-04).
 */
import type { DatosCheckout, ErroresCheckout } from '../../utilidades/checkout';
import { Campo } from './Campo';

interface Props {
  datos: DatosCheckout;
  errores: ErroresCheckout;
  alCambiar: (cambio: Partial<DatosCheckout>) => void;
  alSalirDelCampo: (campo: keyof DatosCheckout) => void;
}

export function PanelContacto({ datos, errores, alCambiar, alSalirDelCampo }: Props) {
  return (
    <section className="panel" aria-labelledby="ck-contacto">
      <div className="panel-cab">
        <h2 id="ck-contacto">Tus datos</h2>
      </div>

      <div className="panel-cuerpo">
        <Campo id="ck-nombre" etiqueta="Nombre y apellido" error={errores.nombre}>
          {(atributos) => (
            <input
              {...atributos}
              type="text"
              autoComplete="name"
              value={datos.nombre}
              onChange={(evento) => alCambiar({ nombre: evento.target.value })}
              onBlur={() => alSalirDelCampo('nombre')}
            />
          )}
        </Campo>

        <div className="fila-campos">
          <Campo id="ck-email" etiqueta="Correo" error={errores.email}>
            {(atributos) => (
              <input
                {...atributos}
                type="email"
                autoComplete="email"
                inputMode="email"
                value={datos.email}
                onChange={(evento) => alCambiar({ email: evento.target.value })}
                onBlur={() => alSalirDelCampo('email')}
              />
            )}
          </Campo>

          <Campo id="ck-telefono" etiqueta="Telefono" error={errores.telefono}>
            {(atributos) => (
              <input
                {...atributos}
                type="tel"
                autoComplete="tel"
                inputMode="tel"
                placeholder="+56 9 1234 5678"
                value={datos.telefono}
                onChange={(evento) => alCambiar({ telefono: evento.target.value })}
                onBlur={() => alSalirDelCampo('telefono')}
              />
            )}
          </Campo>
        </div>

        <label className="opcion-casilla">
          <input
            type="checkbox"
            checked={datos.aceptaPromociones}
            onChange={(evento) => alCambiar({ aceptaPromociones: evento.target.checked })}
          />
          Quiero recibir ofertas y novedades por correo. Puedo darme de baja cuando quiera.
        </label>
      </div>
    </section>
  );
}
